import { useEffect, useState, useRef } from "react";
import TypingIndicator from "../TypingIndicator";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Plugin rehype pour unwrapper les <p> premiers enfants des <li>
function rehypeUnwrapLiParagraphs() {
  return (tree) => {
    function walk(node) {
      if (node.children) {
        node.children.forEach(walk);
        if (node.tagName === 'li' && node.children[1]?.tagName === 'p') {
          node.children = [...node.children[1].children, ...node.children.slice(2)];
        }
      }
    }
    walk(tree);
  };
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getRandomDelay(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function normalizeMarkdown(text) {
  return text
    .replace(/\\n/g, "\n")
    .replace(/^(\d+)\.\s+(.*)$/gm, (_, num, content) => {
      // Supprimer tous les gras existants
      let cleanContent = content.replace(/\*\*/g, "");
      // Supprimer espaces + ":" à la fin, puis les remettre correctement
      cleanContent = cleanContent.replace(/\s*:\s*$/, "");
      return `### **${num}. ${cleanContent}:**`;
    });
}

function sanitizeTyping(text) {
  // Retirer ** et __ uniquement pendant le typing
  return text.replace(/\*\*/g, "").replace(/__/g, "");
}


export default function HumanTyping({ firstLoad, text, sentenceDone, messageId }) {
  const humanRef = useRef(null);
  const [displayed, setDisplayed] = useState(""); // texte en cours d'affichage
  const [done, setDone] = useState(false);
  const [showTyping, setShowTyping] = useState(false);

  useEffect(() => {
    setDone(false);

    const cleanText = normalizeMarkdown(text)

    if (firstLoad) {
      // tout afficher d’un coup
      setDisplayed(cleanText);
      setDone(true);
    } else {
      // effet typing
      async function playTyping() {
        setShowTyping(true);
        let currentText = "";
        for (let char of cleanText) {
          currentText += char;
          setDisplayed(currentText);
          setShowTyping(false);
          if (char === "\n") {
            // pause plus longue aux retours à la ligne
            // await sleep(getRandomDelay(200, 400));
            await sleep(getRandomDelay(1, 1));
          } else {
            // vitesse normale pour les caractères
            // await sleep(getRandomDelay(5, 15));
            await sleep(getRandomDelay(1, 1));
          }
        }
        setShowTyping(false);
        setDone(true);
      }
      playTyping();
    }
  }, [text]);

  useEffect(() => {
    if (done) sentenceDone(messageId);
  }, [done]);

  return (
    <div ref={humanRef} className="chat-text">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeUnwrapLiParagraphs]}
        components={{
          ul: ({ordered, ...props}) => <ul className="list-disc pl-6 mb-2" {...props} />,
          li: ({ordered, ...props}) => <li className="list-disc ml-6 mb-1" {...props} />,
          h3: ({ordered, ...props}) => <h3 className="font-bold mb-1 mb-2" {...props} />,
          p: ({ordered, ...props}) => <p className="mb-6 last:mb-0" {...props} />,
          a: ({href, children, ...props}) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:opacity-80"
              {...props}
            >
              {children}
            </a>
          ),
        }}
        className="text-base leading-tight flex flex-col gap-0 text-[#d4d4d8]"
      >
        {displayed}
      </ReactMarkdown>
      {showTyping && (
        <div className="pt-5">
          <TypingIndicator />
        </div>
      )}
    </div>
  );
}
